import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { SchedulingRoutingModule } from "./scheduling-routing.module";
import { DataComponent } from "./data/data.component";
import { SchedulingComponent } from "./scheduling.component";
import { MatToolbarModule } from "@angular/material/toolbar";
import { SchedulesComponent } from "./schedules/schedules.component";
import { TasksComponent } from "./tasks/tasks.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { MatTableModule } from "@angular/material/table";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatFormField, MatFormFieldModule, MatLabel } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatTreeModule } from "@angular/material/tree";
import { MatAccordion, MatExpansionModule } from "@angular/material/expansion";
import { MatSelectModule } from "@angular/material/select";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatChipsModule } from '@angular/material/chips';
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatDividerModule } from "@angular/material/divider";
import { MatAutocompleteModule} from "@angular/material/autocomplete"
import { JsonPathViewerComponent } from "../common/json-path-viewer/json-path-viewer.component";
import { NgxJsonViewerModule } from "ngx-json-viewer";
import { FilterAutocompleteComponent } from "@nucleus/ui-base";
import { ScheduleComponent } from "./schedules/schedule/schedule.component";
import { SchemaFormComponent } from "../common/schema-form/schema-form.component";
import { MatDatepickerModule, MatSingleDateSelectionModel } from "@angular/material/datepicker";
import { MatTimepickerModule } from "@angular/material/timepicker";
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { HourlyScheduleOptionsComponent } from "./schedules/schedule/hourly-schedule-options/hourly-schedule-options.component";
import { MonthlyScheduleOptionsComponent } from "./schedules/schedule/monthly-schedule-options/monthly-schedule-options.component";
import { WeeklyScheduleOptionsComponent } from "./schedules/schedule/weekly-schedule-options/weekly-schedule-options.component";
import { DailyScheduleOptionsComponent } from "./schedules/schedule/daily-schedule-options/daily-schedule-options.component";
import { YearlyScheduleOptionsComponent } from "./schedules/schedule/yearly-schedule-options/yearly-schedule-options.component";
import { MatTabsModule } from "@angular/material/tabs";
import { ScheduleTimeRangeChartComponent } from "./schedules/schedule/schedule-time-range-chart/schedule-time-range-chart.component";
import { SchedulerEventsGanttComponent } from "./schedules/schedule/scheduler-events-gantt/scheduler-events-gantt.component";
import { SchedulerEventsTableComponent } from "./schedules/schedule/scheduler-events-table/scheduler-events-table.component";
import { LucideAngularModule, ChevronLeft, ChevronRight } from 'lucide-angular';
import { MatSliderModule } from '@angular/material/slider';
import { TimeRangeSelectorComponent } from "./schedules/schedule/time-range-selector/time-range-selector.component";
import { CronSchedulerOptionsComponent } from "./schedules/schedule/cron-scheduler-options/cron-scheduler-options.component";
import { SimulationOptionsComponent } from "./schedules/schedule/simulation-options/simulation-options.component";
import { PageHeaderComponent } from "@nucleus/ui-base";
import { ListPageComponent } from "@nucleus/ui-base";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ComingSoonComponent } from '@nucleus/ui-common';



@NgModule({
  declarations: [
    SchedulesComponent,
    ScheduleComponent,
    DataComponent,
    SchedulingComponent,
    TasksComponent
    
  ],
  imports: [
    RouterModule,
    MatToolbarModule,
    MatExpansionModule,
    ReactiveFormsModule,
    MatChipsModule,
    CommonModule,
    FormsModule,
    MatIconModule,
    MatTableModule,
    MatCardModule,
    MatSliderModule,
    MatButtonModule,
    MatProgressBarModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormField,
    MatLabel,
    MatInputModule,
    MatTimepickerModule,
    MatAccordion,
    MatFormFieldModule,
    MatSelectModule,
    MatCheckboxModule,
    MatGridListModule,
    MatTreeModule,
    MatSidenavModule,
    MatDividerModule,
    JsonPathViewerComponent,
    MatFormFieldModule,
    MatChipsModule,
    MatAutocompleteModule,
    FilterAutocompleteComponent,
    MatDatepickerModule,
    MatRadioModule,
    MatTabsModule,
    MatButtonToggleModule,
    SchedulingRoutingModule,
    HourlyScheduleOptionsComponent,
    MonthlyScheduleOptionsComponent,
    WeeklyScheduleOptionsComponent,
    DailyScheduleOptionsComponent,
    YearlyScheduleOptionsComponent,
    CronSchedulerOptionsComponent,
    ScheduleTimeRangeChartComponent,
    SchedulerEventsGanttComponent,
    SchedulerEventsTableComponent,
    LucideAngularModule.pick({ ChevronLeft, ChevronRight }),
    TimeRangeSelectorComponent,
    SimulationOptionsComponent,
    PageHeaderComponent,
    ListPageComponent,
    MatTooltipModule,
    ComingSoonComponent,
    SchemaFormComponent,
],
  bootstrap: [SchedulingComponent]
})
export class SchedulingModule {}
